import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Translation } from "./navigation-entities/Translation.model";
import { QuizResponse } from "./QuizResponse.model";

export class Quiz extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  description?: string;

  numero?: number;

  availableResponse?: string;

  status?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NavigationProperty({ TargetType: Translation })
  translations?: Translation[];

  @NavigationProperty({ TargetType: QuizResponse })
  quizResponses?: QuizResponse[];

  GetType(): IEntityMetaData {
    return Quiz.getMetaData();
  }
}
